'use client';

import { Book, Title } from 'types';
import TitleAttributes from '@/components/product/title-attributes';
import { useRouter } from 'next/navigation';
import Links from '@/lib/helpers/link-helper';

interface ProductFiltersClientProps {
  titleData?: Title;
  bookData?: Book;
}
export default function ProductFiltersClient({ titleData, bookData }: ProductFiltersClientProps) {
  const router = useRouter();

  if (bookData) titleData.selected_listing = bookData;

  return (
    <TitleAttributes
      title={titleData}
      setSelectedListing={listing => {
        router.push(Links.title(titleData, (listing as Book)?.id).show.url);
      }}
    />
  );
}